import type { Article } from "@/data/helpData"
import { User, Clock } from "lucide-react"

interface ArticleCardProps {
  article: Article
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out overflow-hidden transform hover:-translate-y-1">
      <a href={`/help/articles/${article.slug}`} className="block">
        <div className="h-3 bg-gradient-to-r from-purple-600 to-purple-800"></div>
        <div className="p-6">
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mb-3 bg-purple-100 dark:bg-purple-900/50 text-purple-800 dark:text-purple-300 hover:bg-purple-200 dark:hover:bg-purple-900/70 border border-purple-200 dark:border-purple-800">
            {article.category}
          </span>
          <h3 className="text-lg font-semibold text-purple-900 dark:text-purple-300 group-hover:text-purple-700 dark:group-hover:text-purple-400 mb-2">
            {article.title}
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-4 text-sm">{article.excerpt}</p>
          <div className="flex items-center text-xs text-gray-500 dark:text-gray-500">
            <div className="flex items-center mr-4">
              <User className="h-3 w-3 mr-1" />
              <span>{article.author}</span>
            </div>
            <div className="flex items-center">
              <Clock className="h-3 w-3 mr-1" />
              <span>{article.readTime}</span>
            </div>
          </div>
        </div>
      </a>
    </div>
  )
}